module.exports = __webpack_public_path__ + "static/media/pla_green_strew3.995b136e.png";